import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";


function AccountHeaderFormatter(props) {
    return (
        <Box
            sx={{
                display: 'grid',
                gridAutoFlow: 'column',
                overflowX: 'auto',
                backgroundColor: (theme) => theme.palette.secondary.lighter,
                minHeight: "100px",
                width: "100%",
                height: "100%"
            }}
        >
            <Box
                sx={{
                    margin: (theme) => theme.spacing(0),
                    backgroundColor: "white",
                    border: (theme) => `1px solid ${theme.palette.secondary.light}`,
                    borderRadius: 1,
                    padding: (theme) => theme.spacing(1),
                }}
            >
                {props.title !== undefined && <Typography
                    sx={{
                        textTransform: 'uppercase',
                        margin: "15px 15px -15px",
                    }}
                >
                    {props.title}
                </Typography>}
                {props.title !== undefined && <Divider style={{ marginTop: 30, marginBottom: 20 }} />}
                <Box sx={{ margin: 2 }}>
                    {props.body}
                </Box>
            </Box>
        </Box>
    );
}

export default AccountHeaderFormatter;
